import { render, staticRenderFns } from "./PollingRecord.vue?vue&type=template&id=37393883&scoped=true&"
import script from "./PollingRecord.vue?vue&type=script&lang=js&"
export * from "./PollingRecord.vue?vue&type=script&lang=js&"
import style0 from "./PollingRecord.vue?vue&type=style&index=0&id=37393883&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37393883",
  null
  
)

export default component.exports